<template>
  <g>
    <g transform="scale(0.6)">
        <text transform="matrix(1 0 0 1 175 570)" class="name"
            >서보모터{{ number }}</text
        >
        <g>
            <path
                class="st0"
                d="M140.04,548.05V342l-77.41-7.05H51.09c-13.79,0-25-11.21-25-25s11.21-25,25-25h9.76l79.18-7.5V171.25h62.66
            V83.87h36v87.38h62.46v106.01l84.5,7.69h4.44c13.79,0,25,11.21,25,25c0,13.79-11.21,25-25,25h-5.36l-83.58,7.91v205.19H140.04z
            M220.59,514.18c-3.55,0-6.43,2.89-6.43,6.43c0,2.41,1.34,4.6,3.5,5.72l2.93,1.51l2.94-1.51c2.16-1.11,3.5-3.3,3.5-5.72
            C227.03,517.07,224.14,514.18,220.59,514.18z"
            />
            <rect x="189.69" y="27.87" class="st0" width="62" height="62" />
        </g>
        <line class="st1" x1="230.69" y1="258.87" x2="230.69" y2="86.87" />
        <line class="st2" x1="220.69" y1="258.87" x2="220.69" y2="86.87" />
        <line class="st3" x1="210.69" y1="258.87" x2="210.69" y2="86.87" />
        <g>
            <g>
                <g>
                    <path
                        class="st4"
                        d="M226.05,176.74v10.03c3.84,1.98,6.48,5.98,6.48,10.6c0,6.59-5.34,11.93-11.93,11.93
                    c-6.59,0-11.93-5.34-11.93-11.93c0-4.62,2.63-8.62,6.48-10.6v-10.03h-69.6v365.8h69.6v-11.33c-3.84-1.98-6.48-5.98-6.48-10.6
                    c0-6.59,5.34-11.93,11.93-11.93c6.59,0,11.93,5.34,11.93,11.93c0,4.62-2.63,8.62-6.48,10.6v11.33h69.6v-365.8H226.05z"
                    />
                    <circle class="st5" cx="176.26" cy="200.58" r="9.06" />
                    <circle class="st5" cx="263.4" cy="200.58" r="9.06" />
                    <circle class="st5" cx="176.26" cy="516.34" r="9.06" />
                    <circle class="st5" cx="263.4" cy="516.34" r="9.06" />
                </g>
                <rect
                    x="145.54"
                    y="228.51"
                    class="st6"
                    width="150.12"
                    height="262.27"
                />
            </g>
            <path
                class="st5"
                d="M279.08,309.71c0-32.3-26.19-58.49-58.49-58.49s-58.49,26.19-58.49,58.49c0,23.36,13.7,43.51,33.49,52.88
            v17.43c0,13.72,11.12,24.84,24.84,24.84c13.72,0,24.84-11.12,24.84-24.84v-17.29C265.24,353.43,279.08,333.19,279.08,309.71z"
            />
        </g>
        <rect x="192.69" y="30.87" class="st10" width="56" height="56" />
        <g>
            <path
                class="st11"
                d="M278.69,479.37H162.46c-2.76,0-5-2.24-5-5v-53c0-2.76,2.24-5,5-5h116.23c2.76,0,5,2.24,5,5v53
            C283.69,477.13,281.45,479.37,278.69,479.37z"
            />
            <g>
                <path
                    class="st12"
                    d="M271.69,445.87H169.46c-1.66,0-3-1.34-3-3v-16c0-1.66,1.34-3,3-3h102.23c1.66,0,3,1.34,3,3v16
                C274.69,444.53,273.35,445.87,271.69,445.87z"
                />
            </g>
            <g>
                <path
                    class="st12"
                    d="M181.27,471.69v-7.15l-5.32-9.7h2.47l2.38,4.65c0.65,1.28,1.15,2.3,1.67,3.47h0.05
                c0.47-1.1,1.05-2.2,1.7-3.47l2.42-4.65h2.47l-5.65,9.67v7.17H181.27z"
                />
                <path
                    class="st12"
                    d="M193.05,454.85v7.05h8.15v-7.05h2.2v16.85h-2.2v-7.9h-8.15v7.9h-2.17v-16.85H193.05z"
                />
                <path class="st12" d="M212.2,464.12v1.63h-6.17v-1.63H212.2z" />
                <path
                    class="st12"
                    d="M214.6,469.17c0.63,0.4,2.07,1.02,3.6,1.02c2.82,0,3.7-1.8,3.67-3.15c-0.03-2.27-2.07-3.25-4.2-3.25h-1.22
                v-1.65h1.22c1.6,0,3.62-0.82,3.62-2.75c0-1.3-0.82-2.45-2.85-2.45c-1.3,0-2.55,0.57-3.25,1.07l-0.57-1.6
                c0.85-0.63,2.5-1.25,4.25-1.25c3.2,0,4.65,1.9,4.65,3.87c0,1.67-1,3.1-3,3.82v0.05c2,0.4,3.62,1.9,3.62,4.17
                c0,2.6-2.02,4.87-5.92,4.87c-1.82,0-3.42-0.58-4.22-1.1L214.6,469.17z"
                />
                <path
                    class="st12"
                    d="M237.69,463.39c0,5.52-2.05,8.57-5.65,8.57c-3.17,0-5.32-2.97-5.37-8.35c0-5.45,2.35-8.45,5.65-8.45
                C235.75,455.17,237.69,458.22,237.69,463.39z M228.87,463.64c0,4.22,1.3,6.62,3.3,6.62c2.25,0,3.32-2.62,3.32-6.77
                c0-4-1.02-6.62-3.3-6.62C230.27,456.87,228.87,459.22,228.87,463.64z"
                />
                <path
                    class="st12"
                    d="M250.52,463.39c0,5.52-2.05,8.57-5.65,8.57c-3.17,0-5.32-2.97-5.37-8.35c0-5.45,2.35-8.45,5.65-8.45
                C248.57,455.17,250.52,458.22,250.52,463.39z M241.7,463.64c0,4.22,1.3,6.62,3.3,6.62c2.25,0,3.32-2.62,3.32-6.77
                c0-4-1.02-6.62-3.3-6.62C243.1,456.87,241.7,459.22,241.7,463.64z"
                />
                <path
                    class="st12"
                    d="M253.82,470.14c0.47,0.05,1.02,0,1.77-0.08c1.27-0.17,2.47-0.7,3.4-1.57c1.07-0.97,1.85-2.4,2.15-4.32h-0.08
                c-0.9,1.1-2.2,1.75-3.82,1.75c-2.92,0-4.8-2.2-4.8-4.97c0-3.07,2.22-5.77,5.55-5.77s5.37,2.7,5.37,6.85c0,3.57-1.2,6.07-2.8,7.62
                c-1.25,1.22-2.97,1.97-4.72,2.17c-0.8,0.13-1.5,0.15-2.02,0.13V470.14z M254.62,460.79c0,2.02,1.22,3.45,3.12,3.45
                c1.47,0,2.63-0.72,3.2-1.7c0.13-0.2,0.2-0.45,0.2-0.8c0-2.77-1.02-4.9-3.32-4.9C255.94,456.85,254.62,458.5,254.62,460.79z"
                />
            </g>
            <g>
                <path
                    class="st13"
                    d="M182.93,435.95c-0.08-1.5-0.18-3.31-0.16-4.66h-0.05c-0.37,1.26-0.82,2.61-1.36,4.1l-1.9,5.23h-1.06
                l-1.75-5.14c-0.51-1.52-0.94-2.91-1.25-4.19h-0.03c-0.03,1.34-0.11,3.15-0.21,4.77l-0.29,4.63h-1.33l0.75-10.79h1.78l1.84,5.22
                c0.45,1.33,0.82,2.51,1.09,3.63h0.05c0.27-1.09,0.66-2.27,1.14-3.63l1.92-5.22h1.78l0.67,10.79h-1.36L182.93,435.95z"
                />
                <path
                    class="st13"
                    d="M195.92,435.19c0,3.71-2.26,5.68-5.01,5.68c-2.85,0-4.85-2.21-4.85-5.47c0-3.43,2.13-5.67,5.01-5.67
                C194.02,429.73,195.92,431.99,195.92,435.19z M187.55,435.36c0,2.3,1.25,4.37,3.44,4.37c2.21,0,3.46-2.03,3.46-4.48
                c0-2.14-1.12-4.39-3.44-4.39C188.71,430.86,187.55,432.99,187.55,435.36z"
                />
                <path
                    class="st13"
                    d="M197.73,430.05c0.85-0.13,1.86-0.22,2.96-0.22c2,0,3.43,0.46,4.37,1.34c0.96,0.88,1.52,2.13,1.52,3.87
                c0,1.76-0.54,3.2-1.55,4.19c-1.01,1.01-2.67,1.55-4.77,1.55c-0.99,0-1.82-0.05-2.53-0.13V430.05z M199.12,439.59
                c0.35,0.06,0.86,0.08,1.41,0.08c2.98,0,4.59-1.67,4.59-4.58c0.02-2.54-1.42-4.16-4.37-4.16c-0.72,0-1.26,0.06-1.63,0.14V439.59z"
                />
                <path
                    class="st13"
                    d="M213.97,435.63h-4.19v3.89h4.67v1.17h-6.07V429.9h5.83v1.17h-4.43v3.41h4.19V435.63z"
                />
                <path
                    class="st13"
                    d="M216.26,429.9h1.39v9.62h4.61v1.17h-6V429.9z"
                />
                <path
                    class="st13"
                    d="M230.72,440.34c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.34,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L230.72,440.34z"
                />
                <path
                    class="st13"
                    d="M232.46,430.05c0.7-0.14,1.71-0.22,2.67-0.22c1.49,0,2.45,0.27,3.12,0.88c0.54,0.48,0.85,1.22,0.85,2.05
                c0,1.42-0.9,2.37-2.03,2.75v0.05c0.83,0.29,1.33,1.06,1.58,2.18c0.35,1.5,0.61,2.54,0.83,2.96h-1.44
                c-0.18-0.3-0.42-1.23-0.72-2.58c-0.32-1.49-0.9-2.05-2.16-2.1h-1.31v4.67h-1.39V430.05z M233.86,434.96h1.42
                c1.49,0,2.43-0.82,2.43-2.05c0-1.39-1.01-2-2.48-2.02c-0.67,0-1.15,0.06-1.38,0.13V434.96z"
                />
                <path
                    class="st13"
                    d="M242.89,437.3l-1.12,3.39h-1.44L244,429.9h1.68l3.68,10.79h-1.49l-1.15-3.39H242.89z M246.43,436.21
                l-1.06-3.11c-0.24-0.7-0.4-1.34-0.56-1.97h-0.03c-0.16,0.64-0.34,1.3-0.54,1.95l-1.06,3.12H246.43z"
                />
                <path
                    class="st13"
                    d="M250.94,429.9h5.81v1.17h-4.42v3.59h4.08v1.15h-4.08v4.88h-1.39V429.9z"
                />
                <path
                    class="st13"
                    d="M266.27,440.34c-0.51,0.26-1.54,0.51-2.85,0.51c-3.04,0-5.33-1.92-5.33-5.46c0-3.38,2.29-5.67,5.63-5.67
                c1.34,0,2.19,0.29,2.56,0.48l-0.34,1.14c-0.53-0.26-1.28-0.45-2.18-0.45c-2.53,0-4.21,1.62-4.21,4.45c0,2.64,1.52,4.34,4.15,4.34
                c0.85,0,1.71-0.18,2.27-0.45L266.27,440.34z"
                />
            </g>
        </g>
        <g class="servo-fan">
            <g>
                <path
                    class="st7"
                    d="M390.09,287.95h-4.58l-142.92-13.01v-17.05c0-12.15-9.85-22-22-22l0,0c-12.15,0-22,9.85-22,22v17.04
                L61,287.95h-9.91c-12.15,0-22,9.85-22,22v0c0,12.15,9.85,22,22,22h11.67l135.83,12.37v17.57c0,12.15,9.85,22,22,22l0,0
                c12.15,0,22-9.85,22-22v-16.49l142-13.44h5.5c12.15,0,22-9.85,22-22v0C412.09,297.8,402.25,287.95,390.09,287.95z"
                />
                <g>
                    <circle class="st8" cx="263.38" cy="309.89" r="4" />
                    <circle class="st8" cx="283.38" cy="309.89" r="4" />
                    <circle class="st8" cx="303.38" cy="309.89" r="4" />
                    <circle class="st8" cx="323.38" cy="309.89" r="4" />
                    <circle class="st8" cx="343.38" cy="309.89" r="4" />
                    <circle class="st8" cx="363.38" cy="309.89" r="4" />
                </g>
                <g>
                    <circle class="st8" cx="177.81" cy="309.89" r="4" />
                    <circle class="st8" cx="157.81" cy="309.89" r="4" />
                    <circle class="st8" cx="137.81" cy="309.89" r="4" />
                    <circle class="st8" cx="117.81" cy="309.89" r="4" />
                    <circle class="st8" cx="97.81" cy="309.89" r="4" />
                    <circle class="st8" cx="77.81" cy="309.89" r="4" />
                </g>
                <circle class="st8" cx="220.38" cy="280.87" r="4" />
                <circle class="st8" cx="220.38" cy="260.87" r="4" />
                <circle class="st8" cx="220.38" cy="340.87" r="4" />
                <circle class="st8" cx="220.38" cy="360.87" r="4" />
            </g>
            <g>
                <circle class="st8" cx="220.59" cy="310.87" r="12" />
                <polygon
                    class="st9"
                    points="227.56,306.69 224.77,303.91 220.59,308.09 216.42,303.91 213.63,306.69 217.81,310.87
                213.63,315.05 216.42,317.83 220.59,313.65 224.77,317.83 227.56,315.05 223.38,310.87"
                />
            </g>
        </g>
        <g transform="translate(-3,0)">
            <g class="pin">
                <rect x="202" y="36" class="st14" width="15" height="15" />
                <rect
                    :id="`${pincode}MS`"
                    @click="onClick(`${pincode}MS`)"
                    class="pin-cover terminal"
                    x="201"
                    y="37"
                    width="13"
                    height="13"
                ></rect>
                <text transform="matrix(1 0 0 1 180 10)" class="pin-name"
                    >GND</text
                >
            </g>
            <g class="pin">
                <rect x="216" y="36" class="st14" width="15" height="15" />
                <rect
                    :id="`${pincode}PS`"
                    @click="onClick(`${pincode}PS`)"
                    class="pin-cover terminal"
                    x="215"
                    y="37"
                    width="13"
                    height="13"
                ></rect>
                <text transform="matrix(1 0 0 1 196 10)" class="pin-name"
                    >VCC</text
                >
            </g>
            <g class="pin">
                <rect x="230" y="36" class="st14" width="15" height="15" />
                <rect
                    :id="`${pincode}SG`"
                    @click="onClick(`${pincode}SG`)"
                    class="pin-cover terminal"
                    x="231"
                    y="37"
                    width="13"
                    height="13"
                ></rect>
                <text transform="matrix(1 0 0 1 220 10)" class="pin-name"
                    >SIG</text
                >
            </g>
        </g>
    </g>
  </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'ServoMotor',
  data () {
    return {
      on: false,
      isRotating: 'init',
      timemax: null,
      socket: null
    }
  },
  mounted () {
    this.setPindata(this.data)
  },
  methods: {
    onClick (pin) {
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    },
    start (socket) {
      this.socket = socket
      this.on = true
      this.socket.onmessage = ({ data }) => {
        data = JSON.parse(data)
        this.rotateFan(data.value)
      }
    },
    off () {
      this.on = false
      this.timemax.to(`#${this.data.id} .servo-fan`, 0.5, {
        rotation: 0,
        transformOrigin: '50% 50%'
      })
      this.timemax = null
    },
    rotateFan (deg) {
      window.event.stopPropagation()
      if (this.on) {
        this.timemax = new window.TimelineMax()
        this.timemax.to(`#${this.data.id} .servo-fan`, 0.1, {
          rotation: deg,
          transformOrigin: '50% 50%'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pin-cover{
  display: block;
  stroke: none;
  fill: none;
}
.pin-name{
  display: none;
}
.pin:hover{
  cursor: pointer;
  .pin-cover{
    stroke-width: 3px;
    stroke: black;
    fill: #ff6f61;
  }
  .pin-name{
    font-size: 25px;
    display: block;
  }
}
.selected{
  & .st0{
    display: block;
    stroke-width: 4px;
    stroke: #ff6f61;
  }
}
.name{font-size: 25px}
.st0{fill:#D6D6D6; display: none;}
.st1{fill:none;stroke:#EFC488;stroke-width:10;stroke-miterlimit:10;}
.st2{fill:none;stroke:#BF5A3E;stroke-width:10;stroke-miterlimit:10;}
.st3{fill:none;stroke:#564C3E;stroke-width:10;stroke-miterlimit:10;}
.st4{fill:#276DC9;stroke:#395AA1;stroke-width:5;stroke-miterlimit:10;}
.st5{fill:#395AA1;}
.st6{fill:none;stroke:#395AA1;stroke-width:5;stroke-miterlimit:10;}
.st7{fill:#DBE1DF;}
.st8{fill:#B3B3B3;}
.st9{fill:#666666;}
.st10{fill:#3D3C44;}
.st11{fill:#030507;}
.st12{fill:#FFFFFF;}
.st13{fill:#1A1A1A;}
.st14{stroke:#575058;stroke-width:2;stroke-miterlimit:10;}
</style>
